export default __webpack_public_path__ + "static/media/2_google_ads_svg.f5bcdaf1.svg";